import React from "react";
import { RCCAlert } from "react-common-components";
import { useTranslation } from "src/context/Translations/context";
import {IListIncomeValue} from "./components/List/interface";
import ListTable from "./components/List";

// const getColorTooltipIncome = (origin: number, percent: number) => {
// 	if(origin.toString() === IOriginFinancialManagement.SALES_DEDUCTION || 
// 		origin.toString() === IOriginFinancialManagement.VARIABLE_COSTS || 
// 		origin.toString() === IOriginFinancialManagement.VARIABLE_EXPENSES || 
// 		origin.toString() === IOriginFinancialManagement.OPERATIONAL_EXPENSES || 
// 		origin.toString() === IOriginFinancialManagement.OTHER_EXPENSES){
// 		if(percent >= 100)
// 			return "D13C46";
// 		return "00B38E";
// 	}
// 	if(percent >= 100)
// 		return "00B38E";
// 	return "D13C46";
// };

const TableOfIncomeValues: React.FC<IListIncomeValue> = ({
	data,
	memorizedUrlParams,
	baseVerticalValues,
	valuesOfQuantity,
	childLevel,
	openChartIndicators,
	showColumnLastYear,
	showColumnPlanned,
	showColumnRealized,
	showForecast,
	showHeader,
	showHorizontalAnalysis,
	showOnlyAccumulated,
	showQuantity,
	showVariationPercent,
	showVariationValue,
	showVerticalAnalysis,
	subsidiary,
	title,
	setLoading,
	dtForecast,
	coinPlannedInitials,
	coinRealizedInitials,
	onMouseDown
}) => {
	const { translate } = useTranslation();
	// const [tooltipValue, setTooltipValue] = useState<ITooltipValueIncome | undefined>(undefined);
	
	// const timer = useRef<number>(0);
	// const mouseOver = (value: IValuesTable, titleParam: string, formatEqualsQ: boolean, origin: number) => {
	// 	if(!showColumnPlanned || !showColumnRealized)
	// 		return;
	// 	timer.current = window.setTimeout(() => {
	// 		const valuePredicted = formatEqualsQ ? value.quantityPredicted : value.predicted;
	// 		const valueRealized = formatEqualsQ ? value.quantityRealized : value.realized;
	// 		const percent = valuePredicted !== 0 ? (valueRealized / valuePredicted) * 100 : 100;
	// 		setTooltipValue({
	// 			...value,
	// 			predicted: valuePredicted,
	// 			realized: valueRealized,
	// 			percent,
	// 			title: titleParam,
	// 			color: getColorTooltipIncome(origin, percent)
	// 		});
	// 	}, 300);
	// };
	// const mouseOut = () => {
	// 	window.clearTimeout(timer.current);
	// 	setTooltipValue(undefined);
	// };
	
	return(
		<>
			{data.length === 0 ?  (
				<RCCAlert 
					title={translate("Atenção")}
					description={translate("Não foram encontrados dados")}
				/>
			): (
				<>
					<ListTable 
						data={data}
						childLevel={childLevel}
						setLoading={setLoading}
						memorizedUrlParams={memorizedUrlParams}
						baseVerticalValues={baseVerticalValues}
						valuesOfQuantity={valuesOfQuantity}
						showForecast={showForecast}
						showOnlyAccumulated={showOnlyAccumulated}
						showColumnLastYear={showColumnLastYear}
						showColumnPlanned={showColumnPlanned}
						showColumnRealized={showColumnRealized}
						showVariationValue={showVariationValue}
						showVariationPercent={showVariationPercent}
						showHeader={showHeader}
						showHorizontalAnalysis={showHorizontalAnalysis}
						showQuantity={showQuantity}
						showVerticalAnalysis={showVerticalAnalysis}
						title={title}
						subsidiary={subsidiary}
						openChartIndicators={openChartIndicators}
						// mouseOver={mouseOver}
						// mouseOut={mouseOut}
						dtForecast={dtForecast}
						coinPlannedInitials={coinPlannedInitials}
						coinRealizedInitials={coinRealizedInitials}
						onMouseDown={onMouseDown}
					/>
					{/* <TooltipGaugeChart
						value={tooltipValue ? {
							color: tooltipValue.color,
							percentage: tooltipValue.percent,
							subTitle: tooltipValue.date !== null ? formatDate(tooltipValue.date, currentLanguage, false, "dd/") : "",
							title: tooltipValue.title
						} : undefined}
						linesPreGauge={tooltipValue && <>
							<ListStyles.Line>
								<span>{translate("Planejado")}:</span>
								<span>{formatNumber(tooltipValue.predicted, currentLanguage)}</span>
							</ListStyles.Line>
							<ListStyles.Line>
								<span>{translate("Realizado")}:</span>
								<span>{formatNumber(tooltipValue.realized, currentLanguage)}</span>
							</ListStyles.Line>
						</>}
					/> */}
				</>
			)}
		</>
	);};

export default TableOfIncomeValues;
